import React from 'react';

const MKTEXITINTENTTEMP1 = ({ formData }) => {
  const handleClose = () => {
    const element = document.getElementsByClassName('MKTEXITINTENTTEMP1')[0];
    if (element?.parentNode) {
      element.parentNode.removeChild(element);
    }
  };

  return (
    <div>
      <div className="MKTEXITINTENTTEMP1">
        <div 
          className={`mkt-animated ${formData?.actionProps?.emailSubscriptionForm?.animation}`}
          id="MKTEXITINTENTTEMP1"
        >
          <div id="exit-intent-template">
            <a 
              className="mkt-close-exit-intent mkt-close-2-icon cancel-button" 
              id="close-frame"
              onClick={handleClose}
            />
<img 
          id="ft-exit-intent-empty-image" 
          src={`${process.env.REACT_APP_API_ENDPOINT}/assets/img/emptyImage.jpg`} 
          alt="Empty"
        />
            <div className="exit-intent-template language-handler">
              <div 
                id="exit-intent-template2"
                style={{ background: formData?.actionProps?.emailSubscriptionForm?.background?.color }}
              >
                {formData?.actionProps?.emailSubscriptionForm?.logo?.show && (
                  <div 
                    className="mkt-logo-container"
                    style={{ textAlign: formData?.actionProps?.emailSubscriptionForm?.logo?.position }}
                  >
                    <img src={formData?.actionProps?.emailSubscriptionForm?.logo?.url} alt="Logo" />
                  </div>
                )}

                <div className="exit-intent-title">
                  <span
                    dangerouslySetInnerHTML={{ __html: formData?.actionProps?.emailSubscriptionForm?.heading?.text }}
                    style={{
                      lineHeight: 'normal',
                      fontSize: formData?.actionProps?.emailSubscriptionForm?.heading?.fontsize,
                      color: formData?.actionProps?.emailSubscriptionForm?.heading?.color
                    }}
                  />
                </div>

                <div className="exit-intent-desc">
                  <span
                    dangerouslySetInnerHTML={{ __html: formData?.actionProps?.emailSubscriptionForm?.subheading?.text }}
                    style={{
                      lineHeight: 'normal',
                      fontSize: formData?.actionProps?.emailSubscriptionForm?.subheading?.fontsize,
                      color: formData?.actionProps?.emailSubscriptionForm?.subheading?.color
                    }}
                  />
                </div>

                <div className="template-inputs">
                  <form autoComplete="off" id="ft_exit_intent_template_form">
                    {formData?.actionProps?.emailSubscriptionForm?.overlayfields?.email && (
                      <input
                        id="ftExitIntentEmailField"
                        name="email"
                        placeholder="Enter email address"
                        type="email"
                      />
                    )}
                    <span className="exitintent-error-block" />

                    {formData?.actionProps?.emailSubscriptionForm?.overlayfields?.phone && (
                      <input
                        id="ftExitIntentPhoneField"
                        name="phone"
                        placeholder="Enter phone number"
                        type="text"
                      />
                    )}
                    <span className="exitintent-error-block" />
                  </form>
                </div>

                {formData?.actionProps?.emailSubscriptionForm?.consentMsg?.status && (
                  <p
                    className="mkt-consent-text"
                    dangerouslySetInnerHTML={{ __html: formData?.actionProps?.emailSubscriptionForm?.consentMsg?.text }}
                    style={{
                      color: formData?.actionProps?.emailSubscriptionForm?.consentMsg?.color,
                      lineHeight: 'normal',
                      fontSize: formData?.actionProps?.emailSubscriptionForm?.consentMsg?.fontsize,
                      marginTop: '5px',
                      padding: 0
                    }}
                  />
                )}

                <button
                  className="submit"
                  id="ft_exit_intent_template_submit"
                  style={{ background: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.background?.color }}
                  type="submit"
                >
                  <span
                    dangerouslySetInnerHTML={{ __html: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.text }}
                    style={{ color: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.color }}
                  />
                </button>

                <div
                  className="mkt-close-link cancel-button"
                  id="close-link"
                  style={{ background: formData?.actionProps?.emailSubscriptionForm?.cancelButton?.background?.color }}
                >
                  <span
                    dangerouslySetInnerHTML={{ __html: formData?.actionProps?.emailSubscriptionForm?.cancelButton?.text }}
                    onClick={handleClose}
                    style={{ color: formData?.actionProps?.emailSubscriptionForm?.cancelButton?.color }}
                  />
                </div>
              </div>
            </div>

            <div 
              style={{ 
                width: '100%', 
                padding: '10px 0px', 
                textAlign: 'center', 
                position: 'absolute', 
                bottom: '-44px', 
                filter: 'brightness(100)' 
              }}
            >
              {formData?.exitIntentBranding && (
                <a
                  className="dialog-branding-text"
                  href={`${formData?.entityBrandingUrl}?utm_source=${formData?.sourceDomain}&utm_medium=exitintent&utm_campaign=poweredby`}
                  target="_blank"
                >
                  Powered by
                  <img 
                    style={{ width: 'auto', height: '15px', marginLeft: '10px' }} 
                    src={formData?.poweredByIcon} 
                    alt="Powered by"
                  />
                </a>
              )}
            </div>
            
          </div>
        </div>

        <div 
          className="mkt-overlay-container cancel-button"
          onClick={() => {
            const element = document.getElementsByClassName('MKTEXITINTENTTEMP1')[0];
            if (element?.parentNode) element.parentNode.removeChild(element);
          }}
        />
       
      </div>
    </div>
  );
};

export default MKTEXITINTENTTEMP1;